import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { usePortalAuth } from "../PortalAuthContext";
import { PortalShell } from "./PortalShell";

// External Intake & Collection v1.0 PR 9b §8 — gate for the broker-only
// pages. Redirects unauthenticated visitors to the login page and refuses
// to render broker pages for a non-broker session (a recipient that
// somehow lands on /portal/broker/*).

export function BrokerOnly({ children }: { children: ReactNode }) {
  const auth = usePortalAuth();

  if (auth.loading) {
    return (
      <PortalShell pageTitle="Broker">
        <p className="text-small text-gray-mid">Loading…</p>
      </PortalShell>
    );
  }

  if (!auth.me) {
    return <Navigate to="/portal/login" replace />;
  }

  if (auth.me.kind !== "Broker") {
    return (
      <PortalShell pageTitle="Broker">
        <h1 className="text-h2 font-display text-onyx m-0">Brokers only</h1>
        <p className="text-small text-gray-mid mt-space-3">
          This area is for registered Phoenix Capital brokers.
        </p>
      </PortalShell>
    );
  }

  return <>{children}</>;
}
